export const DEFAULT_OPEN_HOURS = `Monday – Friday: 8:00 AM – 4:30 PM
Sat/Sun: Closed`;

export type OpenHoursRow = { label: string; time: string };

function isSaturday(day: string): boolean {
  const d = day.toLowerCase();
  return d.includes('saturday') || /^sat\b/.test(d);
}

function isSunday(day: string): boolean {
  const d = day.toLowerCase();
  return d.includes('sunday') || /^sun\b/.test(d);
}

/** Parse hours text into display rows; merges Sat + Sun when times match. */
export function parseOpenHoursDisplay(content: string): { rows: OpenHoursRow[] } {
  const lines = content.split('\n').filter((l) => l.trim() !== '');
  const hourLines = lines.filter((l) => l.includes(':'));

  const parsed = hourLines.map((line) => {
    const colonIdx = line.indexOf(':');
    return {
      day: line.substring(0, colonIdx).trim(),
      time: line.substring(colonIdx + 1).trim(),
    };
  });

  const rows: OpenHoursRow[] = [];
  let i = 0;
  while (i < parsed.length) {
    const curr = parsed[i];
    const next = parsed[i + 1];
    if (next && isSaturday(curr.day) && isSunday(next.day)) {
      const sameTime = curr.time.toLowerCase() === next.time.toLowerCase();
      rows.push({
        label: 'Sat/Sun',
        time: sameTime ? curr.time : `${curr.time} / ${next.time}`,
      });
      i += 2;
      continue;
    }
    if (/^sat\s*\/\s*sun/i.test(curr.day) || /saturday\s*[–-]\s*sunday/i.test(curr.day)) {
      rows.push({ label: 'Sat/Sun', time: curr.time });
      i += 1;
      continue;
    }
    rows.push({ label: curr.day, time: curr.time });
    i += 1;
  }

  return { rows };
}
